// extracted by mini-css-extract-plugin
export default {"nextSteps":"Submitted_nextSteps__wfX0s"};